import { render } from "./ProductStock.vue?vue&type=template&id=07ca94e8"
import script from "./ProductStock.vue?vue&type=script&lang=js"
export * from "./ProductStock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__